// Placeholder for your Helio API keys - in a real app, these should be stored securely on the server
const HELIO_PUBLIC_KEY = process.env.REACT_APP_HELIO_PUBLIC_KEY;
const HELIO_SECRET_KEY = process.env.REACT_APP_HELIO_SECRET_KEY;
const HELIO_WALLET_ID = '67ca5f86cad88c555b0cc397';
const PAYLINK_ID = '67ca6330cad88c555b0cc9b0';

interface PayLinkParams {
  amount: number;
  title: string;
  description: string;
  [key: string]: any;
}

/**
 * Creates a payment link using the Helio API
 */
export const createPayLink = async (customParams: Partial<PayLinkParams> = {}): Promise<string> => {
  // In a real app, this request should be made from your backend to protect your secret key
  const params: PayLinkParams = {
    amount: 29.99,
    title: 'Billy Pillow Presale',
    description: 'Limited edition Billy Pillow featuring the Bitcoin cat',
    helio_id: HELIO_WALLET_ID,
    currency_id: 'USD', // Replace with actual currency ID from Helio
    ...customParams
  };

  // This is a dummy implementation - in a real app, make an actual API call to Helio
  console.log('Creating pay link with params:', params);
  
  // Return a fake payment URL for demo purposes
  return 'https://app.hel.io/pay/67ca6330cad88c555b0cc9b0';
};

/**
 * Fetch current sales count from your backend
 */
export const getSalesCount = async (): Promise<number> => {
  try {
    const response = await fetch(
      `https://api.hel.io/v1/paylink/${PAYLINK_ID}/transactions?apiKey=${HELIO_PUBLIC_KEY}`,
      {
        headers: {
          'Authorization': `Bearer ${HELIO_SECRET_KEY}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch sales count');
    }

    const data = await response.json();
    return data.length;
  } catch (error) {
    console.error('Error fetching sales count:', error);
    throw error;
  }
}; 